export default __webpack_public_path__ + "static/media/M-Haseeb-Asghar-Web Developer-Resume-c-n.94d28b50.pdf";